/* ¿Esta tarea de Mis pendientes te la derivaron desde Avisos de ruta?
 *
 * Nico, 06/10: «si lo derivo a Andy, que aparezca en la ticketera de Andy».
 * El «Derivar a…» de Avisos de ruta (el bot) le deja la tarea al que la
 * recibe, y la pantalla la tiene que distinguir de las que uno anotó a mano:
 * quién se la derivó, la foto y el link a la novedad.
 *
 * Con la migración 20261007000000 eso viene en columnas (`origen`,
 * `origen_por`, `foto_url`, `origen_url`). Sin ella, el bot la crea igual
 * con lo mínimo —el renglón «Foto de un chofer: … — te la derivó Nico» y los
 * links en la nota—, y de ahí se saca lo mismo. Devuelve `{ por, foto, aviso,
 * ref }` o `null` si es una tarea común. Sólo se aceptan links http(s): lo que
 * se pinta como link no puede ser un `javascript:`.
 *
 * `ref` es el id del aviso en `avisos_ruta` ("" si no se sabe): de ahí sale el
 * WhatsApp desde el que escribió el chofer, que Nico pidió tocable (09/10).
 * Viene en `origen_ref`; en las viejas, sin esa columna, se saca del `?ver=`
 * del link al aviso, que es el mismo id. Sólo dígitos: es lo que se le va a
 * preguntar a la base.
 */
export const ORIGEN_AVISOS = "avisos_ruta";

const RE_DERIVADA = /^(?:Foto|Mensaje) de un chofer: .+ — te l[ao] derivó (.+)$/;

const link = (v) => (/^https?:\/\//i.test(String(v || "").trim()) ? String(v).trim() : "");

const soloId = (v) => (/^\d+$/.test(String(v ?? "").trim()) ? String(v).trim() : "");
const idDelLink = (url) => soloId((/[?&]ver=(\d+)(?:&|#|$)/.exec(url || "") || [])[1]);

// El renglón con el link al aviso, igual en la nota de la tarea y en el
// detalle del ticket (bot: `avisos_derivar.nota_tarea`).
const RENGLON_AVISO = "En Avisos de ruta: ";

export function derivadaDe(t) {
  if (!t) return null;
  if (t.origen === ORIGEN_AVISOS) {
    const aviso = link(t.origen_url);
    return {
      por: t.origen_por || "",
      foto: link(t.foto_url),
      aviso,
      ref: soloId(t.origen_ref) || idDelLink(aviso),
    };
  }
  if (t.origen) return null;
  const m = RE_DERIVADA.exec(String(t.texto || ""));
  if (!m) return null;
  const renglon = (prefijo) => {
    const l = String(t.nota || "").split("\n").find((x) => x.startsWith(prefijo)) || "";
    return link(l.slice(prefijo.length));
  };
  const aviso = renglon(RENGLON_AVISO);
  return { por: m[1].trim(), foto: renglon("Foto: "), aviso, ref: idDelLink(aviso) };
}

/* ¿De qué aviso de ruta salió este ticket? El id, o "" si no salió de uno.
 *
 * El «Derivar a…» de Avisos de ruta le abre un TICKET a quien tiene área
 * (taller, furgones: bot, `avisos_derivar.crear_ticket`) y una tarea a quien
 * no. Es el mismo reporte de un chofer, y Nico (09/10) quiere su número
 * tocable «en cualquiera que venga de parte de un chofer»: si a Mis pendientes
 * le llega con el WhatsApp y a la ticketera sin él, el mismo aviso se ve
 * distinto según a quién se lo derivaron. El ticket no tiene `origen_ref`;
 * el id sale del renglón «En Avisos de ruta: …?ver=<id>» del detalle.
 *
 * SÓLO CON `origen === "avisos_ruta"`. Esa marca la pone únicamente el bot
 * (`abrir_ticket_derivado` es sólo service_role): sin ella, cualquiera que
 * abre un ticket desde el hub podría pegar un `?ver=` ajeno en el detalle y
 * hacer aparecer el número de un chofer que no tiene nada que ver. Y se lee el
 * ÚLTIMO renglón con ese prefijo: el bot lo escribe al final, abajo de lo que
 * escribieron el chofer y quien derivó, que puede traer cualquier cosa. */
export function avisoDelTicket(ticket) {
  if (!ticket || ticket.origen !== ORIGEN_AVISOS) return "";
  const renglones = String(ticket.detalle || "")
    .split("\n")
    .filter((x) => x.startsWith(RENGLON_AVISO));
  const ultimo = renglones[renglones.length - 1] || "";
  return idDelLink(link(ultimo.slice(RENGLON_AVISO.length)));
}
